import React, { useContext, useEffect, useRef, useState } from "react";
import PropTypes from "prop-types";
import Glide from "@glidejs/glide";
import { DocumentContext } from "~context/DocumentContext";
import Arrow from "~components/svg/Arrow";

const ReviewGrid = ({
  bulletColor,
  className,
  items,
  keyPrefix,
  onUpdate,
  withArrows,
  withBullets
}) => {
  const { windowWidth, device } = useContext(DocumentContext);

  const glideRef = useRef();

  const [activeIndex, setActiveIndex] = useState(0);
  const [glide, setGlide] = useState(null);

  //

  const carouselNext = () => {
    if (!glide) {
      return;
    }

    glide.go(`<`);
  };

  const carouselPrev = () => {
    if (!glide) {
      return;
    }

    glide.go(`>`);
  };

  // useEffect(() => {
  // TODO : stop memory leak
  // }, []);

  useEffect(() => {
    if (!glideRef?.current || !windowWidth || glide) {
      return;
    }
    let reviewNum = 3;
    let gapNum = 30;
    if (device != `desktop`){
      reviewNum = 1;
      gapNum = 5;
    }
    const glideCarousel = new Glide(`#${keyPrefix}-glide`, {
      autoplay: 6000,
      gap: gapNum,
      hoverpause: true,
      perView: reviewNum,
      type: `carousel`
    });

    glideCarousel.on(`run`, () => {
      setActiveIndex(glideCarousel.index);

      onUpdate(glideCarousel.index);
    });

    glideCarousel.on(`swipe.start`, () => {
      glideCarousel.update({
        autoplay: false
      });
    });

    glideCarousel.mount();

    setGlide(glideCarousel);
  }, [glideRef, windowWidth]);

  //

  return (
    <section
      key={`${keyPrefix}-container`}
      className={`carousel ${className ||
        `w-full relative`} flex items-center justify-center`}
    >
      {withArrows && (
        <button
          type="button"
          className="slider__arrow slider__arrow--left pt-v1 pb-v1 pl-v1 flex items-center justify-start"
          onClick={carouselNext}
        >
          <Arrow className="review__arrow" color="black" direction=">" />
        </button>
      )}

      <div className="carousel__glide w-full relative block">
        <div id={`${keyPrefix}-glide`} ref={glideRef} className="glide">
          <div className="glide__track" data-glide-el="track">
            <ul className="glide__slides">
              {items.map((itemJSX, itemIndex) => {
                const key = `${keyPrefix}-item-${itemIndex}`;

                return (
                  <li key={key} className="glide__slide relative">
                    {itemJSX}
                  </li>
                );
              })}
            </ul>
          </div>

          {withBullets && device != 'mobile' && (
            <div
              className="glide__bullets slider__bullets relative mt-6 flex items-center justify-center"
              data-glide-el="controls[nav]"
            >
              {items.map((_, itemIndex) => {
                const bulletKey = `${keyPrefix}-bullet-${itemIndex}`;

                return (
                  <button
                    key={bulletKey}
                    type="button"
                    className={`glide__bullet slider__bullet ${
                      activeIndex === itemIndex ? `` : `opacity-50`
                    } bg-${bulletColor}`}
                    data-glide-dir={`=${itemIndex}`}
                  ></button>
                );
              })}
            </div>
          )}
        </div>
      </div>

      {withArrows && (
        <button
          type="button"
          className="slider__arrow slider__arrow--right relative pt-v1 pr-v1 pb-v1 flex items-center justify-end"
          onClick={carouselPrev}
        >
          <Arrow className="review__arrow" color="black" direction="<" />
        </button>
      )}
    </section>
  );
};

ReviewGrid.defaultProps = {
  bulletColor: `white`,
  className: ``,
  keyPrefix: `glide-carousel`,
  onUpdate: () => {},
  withArrows: true,
  withBullets: true
};

ReviewGrid.propTypes = {
  bulletColor: PropTypes.string,
  className: PropTypes.string,
  items: PropTypes.node.isRequired,
  keyPrefix: PropTypes.string,
  onUpdate: PropTypes.func,
  withArrows: PropTypes.bool,
  withBullets: PropTypes.bool
};

export default ReviewGrid;
